<select appSelect [collection]="pageSizeList" [numericValues]="true" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">

</select>
